<script>
import VueHowler from '../../mixins/custom-howler'

export default {
    mixins: [VueHowler],
    props: ['icon', 'myname'],
}
</script>

<template>
    <div></div>
</template>



// WEBPACK FOOTER //
// audio-player.vue?4b1554f7